import { render, staticRenderFns } from "./addGroupQuestion.vue?vue&type=template&id=679d81eb&scoped=true&"
import script from "./addGroupQuestion.vue?vue&type=script&lang=js&"
export * from "./addGroupQuestion.vue?vue&type=script&lang=js&"
import style0 from "./addGroupQuestion.vue?vue&type=style&index=0&id=679d81eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679d81eb",
  null
  
)

export default component.exports